export let mock_dailyplantsummary = {
};



// WEBPACK FOOTER //
// ./src/mocks/dailyplantsummary/index.ts